module.exports = __webpack_public_path__ + "static/locked.c1b7ff80.png";